export const getPrimaryColor = () => {
  if (typeof window !== "undefined") {
    const color = getComputedStyle(document.documentElement).getPropertyValue(
      "--themePrimary",
    );
    return color;
  }
  return "#5f27E0";
};

export const getPrimaryFont = () => {
  if (typeof window !== "undefined") {
    const font = getComputedStyle(document.documentElement).getPropertyValue(
      "--font-family",
    );
    return font;
  }

  return "Euclid Circular B";
};
